import { EmailLink } from "@/components/Common/EmailLink";

const InfoRow = ({ icon, label, value, isEmail = false }) => {
  return (
    <div className="info-row">
      <div className="info-icon">
        <i className={icon} />
      </div>
      <div>
        <span className="info-label">{label}</span>
        <span className="info-value">
          {value ? (isEmail ? <EmailLink withIcon={false} email={value} /> : value) : "—"}
        </span>
      </div>
    </div>
  );
};

export default InfoRow;